module.exports = __webpack_public_path__ + "static/img/icontext.03d6e65e.png";